/* @ngInject */
const movementMetadata = (
  movementFields
) => {
  const self = {}

  self.favoriteSort = [
    'date',
  ]

  self.fields = movementFields

  return self
}

export default movementMetadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/metadata.service.js